<template>
  <qx-card title="列表">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'arriveTime'">
                <span>{{ scope.row[scope.column.property] / 100 }}</span>
              </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions
                  permpisions
                  v-if="
                    (scope.row.agingSts !== null && scope.row.agingSts < 2) ||
                    (scope.row.agingSts === 3 &&
                      scope.row.appealSts !== null &&
                      scope.row.appealSts < 2)
                  "
                >
                  <span
                    class="primary cur"
                    @click="toDetail(scope.row, 'approve')"
                    >审核</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions v-if="!scope.row.appealId">
                  <span
                    class="primary cur"
                    @click="toDetail(scope.row, 'apply')"
                    >申诉</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="toDetail(scope.row)"
                    >查看</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  orderTimeCustomerList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      searchBoxData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'lineNode',
            label: '路段',
          },
          {
            prop: 'orderStartDate',
            label: '离台时间',
          },
          {
            prop: 'arriveTime',
            label: '到达时间',
          },
          {
            prop: 'arriveHour',
            label: '运输时长',
          },
          {
            prop: 'waringTypeName',
            label: '到达时限',
          },
          {
            prop: 'finePrice',
            label: '罚款金额',
          },
          {
            prop: 'userName',
            label: '责任司机',
          },
          {
            prop: 'agingStsName',
            label: '状态',
          },
          {
            prop: 'appealStsName',
            label: '申诉',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderTimeCustomerList,
    handleBeforeGetData () {
      this.searchBoxData = {
        orderId: this.$route.query.id,
        selectType: 2,
      };
    },
    toDetail (item, type = '') {
      let label = '客户时效详情';
      if (type === 'apply') {
        label = '客户时效申诉';
      } else if (type === 'approve') {
        label = '客户时效审核';
      }
      this.jump({
        label,
        url: `/manage/operate/order/deal/orderDetailTab/detail?id=${item.agingId}&type=${type}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
